/**
 * Material UI
 */
import { createTheme } from '@mui/material/styles';
/**
 * Const
 */
import { FONTS_LIST } from './helpers/const';

const themeData = window.common_data.theme;
const primaryColor = themeData?.primary || '#fff';

const theme = createTheme({
  type: themeData?.is_dark === true ? 'dark' : 'light',
  palette: {
    primary: {
      main: primaryColor,
      contrastText: themeData?.text_over_primary || '#fff',
    },
    secondary: {
      main: themeData?.secondary || '#fff',
      contrastText: themeData?.text_over_secondary || '#fff',
    },
    textOverPrimary: {
      main: themeData?.text_over_primary || '#fff',
    },
    darkGray: {
      main: '#707070',
    },
    form: {
      main: themeData?.tpl_box_bg || '#fff',
    },
    borderMUI: {
      main: '#dcdcdc',
    },
  },
  typography: {
    fontFamily: FONTS_LIST[themeData?.font] ?? 'Roboto',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
  mixins: {
    ellipses: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    formFieldWrapper: {
      width: '100%',
      marginBottom: '20px',
    },
    marginXAuto: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    marginYAuto: {
      marginBottom: 'auto',
      marginTop: 'auto',
    },
    roundedField: {
      /* Button */
      borderRadius: '23px !important',
      height: 40,
      '& .MuiOutlinedInput-root': {
        borderRadius: 23,
      },
      '& .MuiInputBase-root': {
        height: 40,
      },
      '& .MuiInputLabel-root': {
        top: -6,
      },
      '& .MuiInputLabel-shrink': {
        top: 0,
      },
      '& .MuiSelect-icon, .MuiInputAdornment-positionEnd': {
        transform: 'scale(0.7)',
        color: 'black',
      },
      '& input:focus': {
        border: 'none',
      },
    },
    selectedField: {
      '& .MuiOutlinedInput-root, .MuiOutlinedInput-notchedOutline': {
        borderColor: primaryColor,
        borderWidth: 1,
        borderStyle: 'solid',
      },
      '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: primaryColor,
        borderWidth: 2,
        borderStyle: 'solid',
      },
    },
  },
});
export default theme;
